<ng-container *ngIf="'gridRegistration.meteringConceptSelectionHint' | uiAdaptionVisible$ | async">
  <app-hint-card [outlined]="true" [type]="'info'">
    <div [innerHTML]="'gridRegistration.meteringConceptSelectionHint' | uiAdaptionValue"></div>
  </app-hint-card>
</ng-container>

<ng-container *ngIf="selectedMeteringConcept$ | async as selectedMeteringConcept">
  <h3 style="margin-top: 2rem">Ausgewähltes Messkonzept</h3>
  <mat-card class="item-card">
    <div class="card-content">
      <div class="text-section">
        <div class="item-name">{{ selectedMeteringConcept.name }}</div>
        <div class="item-description">{{ selectedMeteringConcept.description }}</div>
      </div>
      <div class="image-section">
        <img
          [src]="selectedMeteringConcept.imageDocument.url"
          [alt]="selectedMeteringConcept.imageDocument.displayName"
          class="item-image" />
      </div>
    </div>
  </mat-card>
</ng-container>

<ng-container *ngIf="!disable()">
  <mat-tab-group class="concept-tabs" *ngIf="meteringConceptList$ | async as meteringConceptList">
    <mat-tab label="Messkonzepte" *ngIf="meteringConceptList.hasMeteringConceptEntries">
      <mat-accordion class="concept-accordion" multi="true">
        <mat-expansion-panel *ngIf="!!meteringConceptList.meteringConcepts.fullFeedIn.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Volleinspeisung</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.meteringConcepts.fullFeedIn" />
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="!!meteringConceptList.meteringConcepts.fullFeedOut.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Überschusseinspeisung</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.meteringConcepts.fullFeedOut" />
        </mat-expansion-panel>

        <mat-expansion-panel
          *ngIf="!!meteringConceptList.meteringConcepts.commercialAccountingForwarding.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Kaufmännisch-bilanziell</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.meteringConcepts.commercialAccountingForwarding" />
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="!!meteringConceptList.meteringConcepts.other.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Andere Messkonzepte</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.meteringConcepts.other" />
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>

    <mat-tab label="Speicherkonzepte" *ngIf="meteringConceptList.hasStorageConceptEntries">
      <mat-accordion class="concept-accordion" multi="true">
        <mat-expansion-panel *ngIf="!!meteringConceptList.storageConcepts.fullFeedIn.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Volleinspeisung</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.storageConcepts.fullFeedIn" />
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="!!meteringConceptList.storageConcepts.fullFeedOut.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Überschusseinspeisung</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.storageConcepts.fullFeedOut" />
        </mat-expansion-panel>

        <mat-expansion-panel
          *ngIf="!!meteringConceptList.storageConcepts.commercialAccountingForwarding.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Kaufmännisch-bilanziell</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.storageConcepts.commercialAccountingForwarding" />
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="!!meteringConceptList.storageConcepts.other.length">
          <mat-expansion-panel-header>
            <mat-panel-title>Andere Speicherkonzepte</mat-panel-title>
          </mat-expansion-panel-header>
          <app-metering-concept-radio-group
            [control]="control()"
            [items]="meteringConceptList.storageConcepts.other" />
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>
  </mat-tab-group>

  <p class="metering-concept-error" *ngIf="!control().value && control().touched">
    Bitte wählen sie ein Messkonzept aus.
  </p>
</ng-container>
